// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__VBpj3","error":"textarea_error__4XFjg"};